import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserStepRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

interface UserStepResponse extends ApiResponse {
  data: {
    STEP: number
    LEVEL_ID?: number
    [key: string]: any
  }
}

export const useUserStep = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<UserStepResponse, UserStepRequest>()

  return {
    mutateAsync: async (data: UserStepRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/step',
        data,
      })

      queryClient.invalidateQueries({ queryKey: ['userStep'] })

      return result
    },
    isLoading: mutation.isPending,
    error: mutation.error,
  }
}
